<template>
    <div class="" id="contenedor">
        <div>
            <div v-if="col>1 && col<paso" id="linea-doble" class="border w-100"></div>
            <div v-if="col==paso && col>1" id="linea-final" class="border w-50"></div>
            <div v-if="col==1 && paso>1" id="linea-inicial" class="border w-50"></div>

            <i v-if="paso==col && mensaje==mensaje &&paso!=2" 
                    class="fas fa-circle seleccionado">
            </i>

            <i  v-if="col==2 && paso==2" 
                class="fas fa-circle seleccionado-signo"
                style="background:#f4d06d" 
                :title="mensaje"
                v-b-tooltip.hover>
                <span class="badge-signo fas fa-question-circle"/>
            </i>
            
            <!-- ciruclo pendiente -->
            <i v-if="col>paso" class="fas fa-circle pendiente"/>

            <i v-if="col<paso" class="fas fa-circle realizado"/>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        paso: {},
        col: {},
        mensaje: {}
    },
    data(){
        return {
        }
    },
    computed:{
    },
    mounted(){
        return{            
            localValue: this.paso,
        }
    },  
    watch:{
        localValue(newValue){
            this.$emit('input', newValue)
        },
        paso(paso){
            this.localValue = paso            
        },
    }
}
</script>
<style scoped lang="scss">
    .border{
        border: 1px solid #bdbdbd !important;
    }
    .seleccionado-signo{ 
        color: #f4d06d;
        border: 2px solid var(--color-azul);
        border-radius: 5em; 
        position: relative;
		top: 0;
        font-size: 23px;
    }
    .badge-signo{
        top: -0.6rem;
        right: -0.6rem;
        position: absolute;
        font-size: 14px;
        background-color: white;
        color: var(--color-azul);
        border-radius: 5em;         
    }
    #contenedor {
        position: relative;
    }
    #linea-inicial{
        position: relative;
        top: 13px;
        left: 50%;
    }
    #linea-doble{
        position: relative;
        top: 13px;
        border: 2px #bdbdbd;
    }
    #linea-final{
        position: relative;
        top: 13px;
        left: -7px;
    }
    #mensaje-estatus{
        position: relative;
        top: 13px;
        left: -7px;
    }
    .seleccionado{
        color:#f4d06d;
        border: 2px solid var(--color-azul);
        border-radius: 5em; 
        font-size: 23px;
        position: relative;
    }
    .realizado{
        color: #bdbdbd;
        border-radius: 5em; 
        font-size: 23px;
        border: 2px solid #bdbdbd;
        position: relative;
    }

    @media screen and (min-width: 992px) and (max-width: 1199px) {
        .seleccionado-signo{ 
            color: #f4d06d;
            border: 2px solid var(--color-azul);
            border-radius: 5em; 
            position: relative;
            top: 0;
            font-size: 20px;
        }
        .badge-signo{
            top: -0.6rem;
            right: -0.6rem;
            position: absolute;
            font-size: 11px;
            background-color: white;
            color: var(--color-azul);
            border-radius: 5em;             
        }
        #contenedor {
            position: relative;
        }
        #linea-inicial{
            position: relative;
            top: 13px;
            left: 50%;
        }
        #linea-doble{
            position: relative;
            top: 13px;
            border: 2px #bdbdbd;
        }
        #linea-final{
            position: relative;
            top: 13px;
            left: -7px;
        }
        #mensaje-estatus{
            position: relative;
            top: 13px;
            left: -7px;
        }
        .seleccionado{
            color:#f4d06d;
            border: 2px solid var(--color-azul);
            border-radius: 5em; 
            font-size: 20px;
            position: relative;
        }
        .realizado{
            color: #bdbdbd;
            background: #bdbdbd;
            border-radius: 5em; 
            font-size: 20px;
            border: 2px solid #bdbdbd;
            position: relative;
        }
        .pendiente{
            color: white;
            border: 1.5px solid var(--color-azul);
            border-radius: 5em; 
            font-size: 20px;
        }
    }

    @media screen and (min-width: 1200px) {
        .seleccionado-signo{ 
            color: #f4d06d;
            border: 2px solid var(--color-azul);
            border-radius: 5em; 
            position: relative;
            top: 0;
            font-size: 23px;
        }
        .badge-signo{
            top: -0.6rem;
            right: -0.6rem;
            position: absolute;
            font-size: 14px;
            background-color: white;
            color: var(--color-azul);
            border-radius: 5em;             
        }
        #contenedor {
            position: relative;
        }
        #linea-inicial{
            position: relative;
            top: 13px;
            left: 50%;
        }
        #linea-doble{
            position: relative;
            top: 13px;
            border: 2px #bdbdbd;
        }
        #linea-final{
            position: relative;
            top: 13px;
            left: -7px;
        }
        #mensaje-estatus{
            position: relative;
            top: 13px;
            left: -7px;
        }
        .seleccionado{
            color: #f4d06d;
            background: #f4d06d;
            border: 2px solid var(--color-azul);
            border-radius: 5em; 
            position: relative;
            top: 0;
            font-size: 23px;
        }
        .realizado{
            color: #bdbdbd;
            background: #bdbdbd;
            border-radius: 5em; 
            font-size: 23px;
            border: 2px solid #bdbdbd;
            position: relative;
        }
        .pendiente{            
            color: white;
            border: 1.5px solid var(--color-azul);
            border-radius: 5em; 
            font-size: 25px;
        }
    }
</style>